import styled, { css } from 'styled-components';

export const StyledButtonSmall = styled.button(
  ({
    theme,
    backgroundColor = 'oxfordBlue',
    rounded = false,
    loading = false,
  }) => css`
    display: flex;
    justify-content: ${loading ? 'center ' : 'space-between'};
    align-items: center;
    width: ${theme.width.full};
    padding: ${theme.spacing.none} ${theme.spacing.sm};
    background-color: ${theme.colors[backgroundColor]};
    border: none;
    border-radius: ${rounded ? theme.radius.l : theme.radius.xs};
    height: 20px;
  `
);

export const StyledButtonSmallOutlined = styled.button(
  ({
    theme,
    backgroundColor = 'oxfordBlue',
    inverted,
    rounded = false,
    loading = false,
  }) => css`
    display: flex;
    justify-content: ${loading ? 'center ' : 'space-between'};
    align-items: center;
    width: ${theme.width.full};
    padding: ${theme.spacing.none} ${theme.spacing.sm};
    background-color: ${inverted
      ? theme.colors.white
      : theme.colors[backgroundColor]};
    border: 1px solid
      ${inverted ? theme.colors[backgroundColor] : theme.colors.white};
    border-radius: ${rounded ? theme.radius.l : theme.radius.xs};
    font: inherit;
    font-size: ${theme.fontSize.xs};
    font-weight: ${theme.fontWeight.semiBold};
    height: 20px;
  `
);

export const StyledButtonSmallDisabled = styled.button(
  ({ theme, rounded }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacing.none} ${theme.spacing.sm};
    background-color: ${theme.colors.dimGray};
    width: ${theme.width.full};
    border-width: 1px;
    border-radius: ${rounded ? theme.radius.l : theme.radius.xs};
    font: inherit;
    font-size: ${theme.fontSize.xs};
    font-weight: ${theme.fontWeight.semiBold};
    height: 20px;
    opacity: 0.3;
  `
);
